import React from 'react'

interface IParcelFiltereCard {
    parcelStatus: string;
    setParcelStatus: (parcelStatus: string) => void;
    parcelId: string;
    setParcelId: (parcelId: string) => void;
    orderId: string;
    setOrderId: (orderId: string) => void;
    phoneNumber: string;
    setPhoneNumber: (phoneNumber: string) => void;
    exportToExcel: () => void;
    fromDate: string;
    setFromDate: (fromDate: string) => void;
    toDate: string;
    setToDate: (toDate: string) => void;
    addParcel: () => void;
}

const parcelStatusList = [
    "Pending",
    "Delivered",
    "Returned",
    "Cancelled",
]

const ParcelFilterCard = ({ parcelStatus, setParcelStatus, parcelId, setParcelId, orderId, setOrderId, phoneNumber, setPhoneNumber, exportToExcel, fromDate, setFromDate, toDate, setToDate, addParcel }: IParcelFiltereCard) => {
    return (
        <div className="bg-white shadow-lg rounded-lg p-4 justify-between flex flex-row gap-10 items-end">
            <div className="flex flex-col justify-between w-full gap-4">
                <div className="flex flex-col sm:flex-row md:flex-col lg:flex-row justify-between items-center gap-4">
                    <div className="text-2xl font-bold text-text_1">Parcel List</div>
                    <div className='flex flex-col sm:flex-row w-full sm:w-fit gap-4'>
                        <div
                            onClick={() => {
                                setParcelStatus("All");
                                setParcelId('');
                                setOrderId('');
                                setPhoneNumber('');
                                setFromDate('');
                                setToDate('');
                            }}
                            className="py-2 px-3 border border-warning text-warning rounded bg-warning/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-warning hover:animate-pulse hover:text-white"
                        >
                            Reset Filters
                        </div>
                        <div
                            onClick={addParcel}
                            className="py-2 px-3 border border-secondary text-secondary rounded bg-secondary/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-secondary hover:animate-pulse hover:text-white"
                        >
                            Add Parcel
                        </div>
                        <div
                            onClick={exportToExcel}
                            className="py-2 px-3 border border-green-500 text-green-500 rounded bg-green-500/10 flex items-center justify-center gap-2 cursor-pointer transition-all hover:bg-green-500 hover:animate-pulse hover:text-white"
                        >
                            Export to Excel
                        </div>
                    </div>
                </div>
                <div className="flex flex-col gap-4 items-center w-full">
                    <div className='flex w-full flex-col xl:flex-row gap-4'>
                        <div className='w-full flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4'>
                            <select
                                id="parcel-status"
                                value={parcelStatus}
                                onChange={(e) => setParcelStatus(e.target.value)}
                                className="w-full border-2 p-2 rounded-lg focus:outline-none focus:border-secondary"
                            >
                                <option value="All">
                                    All
                                </option>
                                {parcelStatusList?.map((parcel, index) => {
                                    return (
                                        <option key={index} value={parcel}>
                                            {parcel}
                                        </option>
                                    )
                                })}
                            </select>
                            <input
                                type="text"
                                className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                                placeholder={`Search by parcel id`}
                                onChange={(e) => setParcelId(e.target.value)}
                                value={parcelId}
                            />
                        </div>
                        <div className='w-full flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4'>
                            <input
                                type="text"
                                className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                                placeholder={`Search by order id`}
                                onChange={(e) => setOrderId(e.target.value)}
                                value={orderId}
                            />
                            <input
                                type="text"
                                className="flex-grow p-2 w-full focus:ring-0 border-2 rounded-lg focus:border-secondary focus:outline-none"
                                placeholder={`Search by phone number`}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                                value={phoneNumber}
                            />
                        </div>
                    </div>
                </div>
                <div className='w-full flex flex-col sm:flex-row md:flex-col lg:flex-row gap-4'>
                    <div className='w-full'>
                        <div className='text-text_1 text-lg font-bold mb-2'>From Date</div>
                        <input type="date" id="start" name="trip-start" value={fromDate} onChange={e => setFromDate(e.target.value)} className='w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none' />
                    </div>
                    <div className='w-full'>
                        <div className='text-text_1 text-lg font-bold mb-2'>To Date</div>
                        <input type="date" id="start" name="trip-start" value={toDate} onChange={e => setToDate(e.target.value)} className='w-full border-2 p-2 rounded-lg focus:border-secondary focus:outline-none' />
                    </div>
                </div>
            </div>
            <div className="h-40 hidden xl:flex">
                <img
                    src="https://res.cloudinary.com/di23omfvx/image/upload/v1692428968/self_driving_car_Road_1_npjom3.gif"
                    alt="self drive"
                    className="h-full w-full"
                />
            </div>
        </div>
    )
}

export default ParcelFilterCard